<template>
  <div>

    <b-alert variant="danger" v-if="Object.keys(errors).length > 0" show>
      {{ errors }}
    </b-alert>

    <b-container></b-container>
    <section id="hero">
      <b-container class="search-inputs-wrapper">
        <b-row>
          <b-col cols="12" sm="6">
            <h1 v-html="$t('landings.customers.title')"></h1>
          </b-col>
        </b-row>
      </b-container>
    </section>

    <b-container>

      <section>
        <h2 v-html="$t('landings.customers.why.title')"></h2>
        <b-row>
          <b-col v-html="$t('landings.professionals.why.description')"></b-col>
        </b-row>
      </section>

      <section id="why">
        <h2 v-html="$t('landings.customers.how.title')"></h2>
        <b-row>
          <b-col>
            <h3 class="mt-5 mb-5" v-html="$t('landings.customers.how.options.title')"></h3>
            <b-row>
              <b-col cols="12" sm="6" md="3">
                <div>
                  <i class="material-icons">
                    fitness_center
                  </i>
                </div>
                {{ $t('landings.customers.how.options.option1') }}
              </b-col>
              <b-col cols="12" sm="6" md="3">
                <div>
                  <i class="material-icons">
                    location_on
                  </i>
                </div>
                {{ $t('landings.customers.how.options.option2') }}
              </b-col>
              <b-col cols="12" sm="6" md="3">
                <div>
                  <i class="material-icons">
                    supervised_user_circle
                  </i>
                </div>
                {{ $t('landings.customers.how.options.option3') }}
              </b-col>
              <b-col cols="12" sm="6" md="3">
                <div>
                  <i class="material-icons">
                    library_books
                  </i>
                </div>
                {{ $t('landings.customers.how.options.option4') }}
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </section>

    </b-container>

    <section id="professional" class="mt-5">
      <b-container>
        <b-row>
          <b-col>
            <h2>
              {{ $t('professionalSection.subTitle') }}
            </h2>
            <p>{{ $t('professionalSection.description') }}</p>
            <b-btn variant="primary" :to="{ name: `ProfessionalsLanding.${$i18n.i18next.language}` }">{{ $t('professionalSection.cta') }}</b-btn>
          </b-col>
        </b-row>
      </b-container>
    </section>

  </div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>

  export default {
    name: 'ProfessionalsLanding',
    components: {
    },
    data () {
      return {
        errors: {}
      }
    },
    mounted () {
      // this.$el.addEventListener('click', this.onClose)
    }
  }
</script>

<style lang="scss" scoped>


  #hero {
    position: relative;
    min-height: 500px;
    background: url(https://finefit.s3.eu-north-1.amazonaws.com/images/header_placeholder.jpg) no-repeat center center;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    overflow: visible;

    .search-inputs-wrapper {
      position: absolute;
      top: 70%;
      left: 50%;
      transform: translate(-50%, -70%);
      width: 100%;
      z-index: 10;
    }

    h1 {
      display: block;
      padding: 1rem;
      box-sizing: border-box;
      color: white;
      font-size: 2rem;
      font-weight: bold;
      text-align: left;
      background: rgba(0,0,0,0.5);
    }
  }

  #why {
    i {
      color: #f1a444;
      font-size: 3rem;
      margin: 2rem 0;
    }
  }

  #communication {
    position: relative;
    min-height: 500px;
    background: url(https://images.pexels.com/photos/34140/pexels-photo.jpg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940) no-repeat center center;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    overflow: visible;

    .container {
      position: relative;
      min-height: 500px;

      .text {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 50%;
        z-index: 10;

        h3 {
          display: block;
          padding: 1rem;
          box-sizing: border-box;
          color: white;
          font-size: 2rem;
          font-weight: bold;
          text-align: left;
          background: rgba(0,0,0,0.5);
        }

        p {
          display: block;
          padding: 1.2rem;
          box-sizing: border-box;
          color: white;
          font-size: 1rem;
          font-weight: bold;
          text-align: left;
          background: rgba(0,0,0,0.5);
        }

        @include media-breakpoint-down(md) {
          width: 100%;
        }
      }
    }
  }

  #offers {
    i {
      color: #f1a444;
      font-size: 3rem;
      margin: 2rem 0;
    }
  }

  section {
    padding: 1rem 0;
  }

  section.thumbs {
    .col {
      padding: 15px;
    }
    a {
      position: relative;
      color: white !important;
      text-transform: uppercase;
      text-decoration: none;

      span {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        border: 1px solid white;
        padding: 0.5rem;
      }
      img {
        width: 100%;
        height: auto;
      }

      &:hover {
        color: white;
        opacity: .9;
      }
    }
  }

  #search-results {
    .services {
      .card {
        border: none;
        border-radius: 0;
      }
      header {
        padding: 0;
        background: transparent;
        border: none;
        border-radius: 0;
      }
      .btn.main-level {
        color: inherit;
        border: none;
        border-radius: 0;
        border-bottom: 2px solid black;
        box-shadow: none;
        background: transparent;
      }
      .btn.second-level {
        border: none;
        box-shadow: none;
      }
      .card-body.third-level {
        padding: 0.5rem 0;

        a.third-level {
          display: block;
          color: black;
          padding: 0.5rem 0;
          border-bottom: 1px solid black;
          white-space: normal;
        }
      }
    }
  }

  section#services {
    .row {
      margin-bottom: -30px;
    }
  }

  #professional {
    position: relative;
    min-height: 400px;
    background: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(https://images.unsplash.com/photo-1517963628607-235ccdd5476c?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=c688dfbe53dcd3cbf32c3b171adff920&auto=format&fit=crop&w=1502&q=80) no-repeat center center;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    text-align: center;
    color: white;
    font-size: 1.5rem;

    .container {
      width: 40%;

      h2 {
        margin-top: 6rem;
        text-align: center;
        font-size: 2rem;
        margin-left: auto;
        margin-right: auto;
      }

      @include media-breakpoint-down(md) {
        width: 80%
      }
    }
  }

  .nav{
    list-style:none;
    margin-left:0;
  }
  .nav > li,
  .nav > li > a{
    display:inline-block;
    *display:inline;
    zoom:1;
  }
  .stacked > li{
    display:list-item;
  }
  .stacked > li > a{
    display:block;
  }


  .flyout, .flyout-alt {
    position: relative;
  }

  .flyout-content {
    position: absolute;
    top: 100%;
    left: -99999px;
    height: 0;
    overflow: hidden;
    z-index: 999;
  }

  .flyout:hover > .flyout-content {
    left: 0;
  }

  .flyout-alt:hover > .flyout-content {
    top: 0;
    left: 100%;
  }

  .flyout:hover > .flyout-content, .flyout-alt:hover > .flyout-content {
    height: auto;
    overflow: visible;
  }

  ul.services {
    > li {
      width: 50% !important;
      > ul.flyout-content {
        /*position: relative;*/
        /*width: 100%;*/
        left: 100% !important;
        top: 0 !important;
      }
    }
    font-size: 0.8rem;
    font-family: sans-serif;
    li {
      display: block;
      margin: 0;
      width: 100%;
      margin-left: 0.1rem;
    }
    a {
      line-height: 1;
      padding: 1em;
      padding-left: 0;
      background-color: white;
      color: black;
      border-bottom: 2px solid black !important;
      white-space: nowrap;
      i {
        font-size: 0.8rem;
      }
    }
    .flyout:hover > a, .flyout-alt:hover > a,
    a:hover {
      color: white;
      background-color: $primary;
      text-decoration: none;
    }
    .flyout-alt > a:after {
      content: "";
    }
    a {
      border: 0 solid #fff;
    }
    .flyout-content {
      background-color: white;
      a {
        border-bottom-width: 1px;
      }
    }
    > li {
      > a {

      }
      &:first-child > a {
        border: none;
      }
    }
    .flyout-alt:hover > .flyout-content {
      top: -1px;
    }
  }
</style>

<style lang="scss" scoped>


  h2 {

  }
</style>
